import { SHOW_MODAL, HIDE_MODAL } from '~/data/constants/modal-constants';

const initialState = {
  type: null,
  properties: {},
};

/**
 * The Modal Reducer
 *
 * @param {any} [state=initialState]
 * @param {any} action
 * @returns
 */
function modal(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        type: action.payload.type,
        properties: action.payload.properties,
      };
    case HIDE_MODAL:
      return initialState;
    default:
      return state;
  }
}

export default modal;



// WEBPACK FOOTER //
// ./src/redux/reducers/modal-reducer.jsx